import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { useSetting } from '../../util/useSetting';
import ShortTask from './components/ShortTasks';
import PracticeTask from './components/PracticeTasks';
import { DATA_1 } from './components/PracticeTask_1_data';
import { DATA_2 } from './components/PracticeTask_2_data';
import { DATA_3 } from './components/PracticeTask_3_data';
import { DATA_4 } from './components/PracticeTask_4_data';
import { DATA_5 } from './components/PracticeTask_5_data';
import { DATA_6 } from './components/PracticeTask_6_data';
import { SHORT_TASK_QUESTIONS_1 } from './components/ShortTask_1_data';
import { SHORT_TASK_QUESTIONS_2 } from './components/ShortTask_2_data';
import { SHORT_TASK_QUESTIONS_3 } from './components/ShortTask_3_data';
import { SHORT_TASK_XY } from './components/ShortTask_XY_data';
import { SHORT_TASK_YZ } from './components/ShortTask_YZ_data';
import { SHORT_TASK_ZX } from './components/ShortTask_ZX_data';
import PracticeTaskAICommentsStyles from './components/PracticeTaskAICommentsStyles.css';
import QuestionnairePage from './components/QuestionnairePage';
import PracticeTaskPreviewPage from './components/PracticeTaskPreviewPage';
import { questionnaire_A1 } from './components/Questionnaire_A1_data';
import { questionnaire_A2 } from './components/Questionnaire_A2_data';
import { questionnaire_B1 } from './components/Questionnaire_B1_data';
import { questionnaire_B2 } from './components/Questionnaire_B2_data';
import { questionnaire_background } from './components/Questionnaire_background';
import { fetchUserDataById } from '../../services2/users.service';
import { insertResearchTaskRecord, studentFetchResearchTaskRecords } from '../../services2/researchTaskRecords.service';
const RESEARCHES = [
    {
        id: '100',
        name: 'Pilot Test',
        image: '/secondary/tasks/11.png',
        subtitle: '研究測試 Pilot Test',
        link: '/platform2/research-practices/preview/100'
    },
    {
        id: '1',
        name: '香港學生睡眠',
        image: '/secondary/tasks/r1.png',
        subtitle: '研究測試 A-1'
    },
    {
        id: '2',
        name: '機器人',
        image: '/secondary/tasks/r2.png',
        subtitle: '研究測試 2'
    },
    {
        id: '3',
        name: '小販文化',
        image: '/secondary/tasks/p1.png',
        subtitle: '研究測試 B-1'
    },
    {
        id: '4',
        name: '香港學生運動',
        image: '/secondary/tasks/p2.png',
        subtitle: '研究測試 B-2'
    },
    {
        id: '5',
        name: '孤獨感',
        image: '/secondary/tasks/p3.png',
        subtitle: '研究測試 C-1'
    },
    {
        id: '6',
        name: '香港氣候變化',
        image: '/secondary/tasks/p4.png',
        subtitle: '研究測試 C-2'
    },

]


// const DICT = {
//     '1': {
//         shortTaskQuestions: SHORT_TASK_QUESTIONS_1,
//         practiceTaskData: DATA_1,
//     },
//     '2': {
//         shortTaskQuestions: SHORT_TASK_QUESTIONS_1,
//         practiceTaskData: DATA_2,
//     },
//     '3': {
//         shortTaskQuestions: SHORT_TASK_QUESTIONS_2,
//         practiceTaskData: DATA_3,
//     },
//     '4': {
//         shortTaskQuestions: SHORT_TASK_QUESTIONS_2,
//         practiceTaskData: DATA_4,
//     },
//     '5': {
//         shortTaskQuestions: SHORT_TASK_QUESTIONS_3,
//         practiceTaskData: DATA_5,
//     },
//     '6': {
//         shortTaskQuestions: SHORT_TASK_QUESTIONS_3,
//         practiceTaskData: DATA_6,
//     },
// }


const GROUPS = {
    '1': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_A1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_A2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_XY)),
        preview1: RESEARCHES[1],
        preview2: RESEARCHES[2],
        task1: JSON.parse(JSON.stringify(DATA_1)),
        task2: JSON.parse(JSON.stringify(DATA_2)),
    },
    '2': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_B1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_B2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_XY)),
        preview1: RESEARCHES[1],
        preview2: RESEARCHES[2],
        task1: JSON.parse(JSON.stringify(DATA_1)),
        task2: JSON.parse(JSON.stringify(DATA_2)),
    },
    '3': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_A1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_A2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_YZ)),
        preview1: RESEARCHES[1],
        preview2: RESEARCHES[2],
        task1: JSON.parse(JSON.stringify(DATA_1)),
        task2: JSON.parse(JSON.stringify(DATA_2)),
    },
    '4': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_B1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_B2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_YZ)),
        preview1: RESEARCHES[1],
        preview2: RESEARCHES[2],
        task1: JSON.parse(JSON.stringify(DATA_1)),
        task2: JSON.parse(JSON.stringify(DATA_2)),
    },
    '5': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_A1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_A2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_YZ)),
        preview1: RESEARCHES[3],
        preview2: RESEARCHES[4],
        task1: JSON.parse(JSON.stringify(DATA_3)),
        task2: JSON.parse(JSON.stringify(DATA_4)),
    },
    '6': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_B1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_B2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_YZ)),
        preview1: RESEARCHES[3],
        preview2: RESEARCHES[4],
        task1: JSON.parse(JSON.stringify(DATA_3)),
        task2: JSON.parse(JSON.stringify(DATA_4)),
    },
    '7': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_A1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_A2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_ZX)),
        preview1: RESEARCHES[3],
        preview2: RESEARCHES[4],
        task1: JSON.parse(JSON.stringify(DATA_3)),
        task2: JSON.parse(JSON.stringify(DATA_4)),
    },
    '8': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_B1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_B2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_ZX)),
        preview1: RESEARCHES[3],
        preview2: RESEARCHES[4],
        task1: JSON.parse(JSON.stringify(DATA_3)),
        task2: JSON.parse(JSON.stringify(DATA_4)),
    },
    '9': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_A1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_A2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_ZX)),
        preview1: RESEARCHES[5],
        preview2: RESEARCHES[6],
        task1: JSON.parse(JSON.stringify(DATA_5)),
        task2: JSON.parse(JSON.stringify(DATA_6)),
    },
    '10': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_B1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_B2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_ZX)),
        preview1: RESEARCHES[5],
        preview2: RESEARCHES[6],
        task1: JSON.parse(JSON.stringify(DATA_5)),
        task2: JSON.parse(JSON.stringify(DATA_6)),
    },
    '11': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_A1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_A2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_XY)),
        preview1: RESEARCHES[5],
        preview2: RESEARCHES[6],
        task1: JSON.parse(JSON.stringify(DATA_5)),
        task2: JSON.parse(JSON.stringify(DATA_6)),
    },
    '12': {
        questionnaire1: JSON.parse(JSON.stringify(questionnaire_B1)),
        questionnaire2: JSON.parse(JSON.stringify(questionnaire_B2)),
        shortTask: JSON.parse(JSON.stringify(SHORT_TASK_XY)),
        preview1: RESEARCHES[5],
        preview2: RESEARCHES[6],
        task1: JSON.parse(JSON.stringify(DATA_5)),
        task2: JSON.parse(JSON.stringify(DATA_6)),
    }
}

// Group	Questionnaire	Block 組合	Test	完整作答順序
// Group 1	Questionnaire A	X + Y	Test A	Questionnaire A1 → Block X + Y → Test A Task 1 → Test A Task 2 → Questionnaire A2
// Group 2	Questionnaire B	X + Y	Test A	Questionnaire B1 → Block X + Y → Test A Task 1 → Test A Task 2 → Questionnaire B2
// Group 3	Questionnaire A	Y + Z	Test A	Questionnaire A1 → Block Y + Z → Test A Task 1 → Test A Task 2 → Questionnaire A2
// Group 4	Questionnaire B	Y + Z	Test A	Questionnaire B1 → Block Y + Z → Test A Task 1 → Test A Task 2 → Questionnaire B2
// Group 5	Questionnaire A	Y + Z	Test B	Questionnaire A1 → Block Y + Z → Test B Task 1 → Test B Task 2 → Questionnaire A2
// Group 6	Questionnaire B	Y + Z	Test B	Questionnaire B1 → Block Y + Z → Test B Task 1 → Test B Task 2 → Questionnaire B2
// Group 7	Questionnaire A	Z + X	Test B	Questionnaire A1 → Block Z + X → Test B Task 1 → Test B Task 2 → Questionnaire A2
// Group 8	Questionnaire B	Z + X	Test B	Questionnaire B1 → Block Z + X → Test B Task 1 → Test B Task 2 → Questionnaire B2
// Group 9	Questionnaire A	Z + X	Test C	Questionnaire A1 → Block Z + X → Test C Task 1 → Test C Task 2 → Questionnaire A2
// Group 10	Questionnaire B	Z + X	Test C	Questionnaire B1 → Block Z + X → Test C Task 1 → Test C Task 2 → Questionnaire B2
// Group 11	Questionnaire A	X + Y	Test C	Questionnaire A1 → Block X + Y → Test C Task 1 → Test C Task 2 → Questionnaire A2
// Group 12	Questionnaire B	X + Y	Test C	Questionnaire B1 → Block X + Y → Test C Task 1 → Test C Task 2 → Questionnaire B2



function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setisLoading] = useState(false)
    const { fontSize } = useSetting();


    const [group, setGroup] = useState('1');

    const [user, setuser] = useState(null)
    // const [school, setSchool] = useState(null)

    async function fetchData() {
        let result = await fetchUserDataById(props.token.token)
        if (result.result) {
            setuser(result.result)
            if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'].includes(result.result.group)) {
                setGroup(result.result.group)
                console.log('Group set to ' + result.result.group)
            }

        }
    }
    useEffect(() => {
        if (props.token.token)
            fetchData()
    }, [props.token.token])


    const [isDoingShortTask, setisDoingShortTask] = useState(true)
    const [isDoingReadingTask, setisDoingReadingTask] = useState(false)

    const [session, setSession] = useState(0);
    // 0 pre questionaaire 1
    // 1 short task 1
    // 2 short task 2
    // 3 task 1 preview page
    // 4 reading task 1
    // 5 task 2 preview page
    // 6 reading task 2
    // 7 post questionaaire 

    const [startTime, setStartTime] = useState(null);


    const handleNextSession = async (data = null) => {
        // if(session >= 7){
        //     navigate('/platform2/research-practices');
        //     return
        // } 
        if (data) {
            await handleSaveASession(data);
        }
        if (session === 0 || session === 1) {
            //reset 5 mins
            setStartTime(new Date().getTime());
        } else if (session === 2) {
            setStartTime(null)
        } else if (session === 3) {
            setStartTime(new Date().getTime());
        } else if (session === 6) {
            setStartTime(new Date().getTime());
        }
        setSession(prev => prev + 1);
    }

    const handleSaveASession = async (data) => {
        setisLoading(true);
        let result = await insertResearchTaskRecord(props.token.token, session, id, startTime, new Date().getTime(), group, data);
        if (result.errno) {
            alert('Failed to save session: ' + result?.message || 'Unknown error');
        } else {
            alert('已保存');
        }
        setisLoading(false);
    }

    const fetchSaveRecords = async () => {
        setisLoading(true);
        let result = await studentFetchResearchTaskRecords(props.token.token, {
            taskId: id,
            group
        });
        if (result.errno) {
            alert('Failed to fetch records: ' + result?.message || 'Unknown error');
        } else {
            if (result.result) {
                if (result.result.filter(record => record.session === 7).length > 0) {
                    setSession(8);
                } else if (result.result.filter(record => record.session === 6).length > 0) {
                    setSession(7);
                    setStartTime(new Date().getTime());
                } else if (result.result.filter(record => record.session === 4).length > 0) {
                    setSession(5);
                    setStartTime(result.result.filter(record => record.session === 4)[0]?.startTime);
                } else if (result.result.filter(record => record.session === 2).length > 0) {
                    setSession(3);
                    setStartTime(null);
                } else if (result.result.filter(record => record.session === 1).length > 0) {
                    setSession(2);
                    setStartTime(new Date().getTime());
                } else if (result.result.filter(record => record.session === 0).length > 0) {
                    setSession(1);
                    setStartTime(new Date().getTime());
                } else {
                    setSession(0);
                    setStartTime(new Date().getTime());
                }
            }
        }
        setisLoading(false);
    }

    useEffect(() => {
        fetchSaveRecords();
    }, [props.token?.token, id, group]);



    if (id == '100') {
        if (session >= 8) {
            return (
                <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px] noto-san-hk p-[16px] font-[900]' style={{ fontSize: fontSize + 4 }}>
                    研究測試已完成

                    <div className='font-[500]'>
                        <button onClick={() => navigate('/platform2/research-practices')}>{`< 返回 全部研究測試`}</button>
                    </div>
                </div>
            )
        }
        return (
            <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px]' style={{ fontSize }}>
                {session === 0 && <QuestionnairePage session={session} data={JSON.parse(JSON.stringify(questionnaire_background))} onSubmit={handleNextSession} />}
                {session === 1 && <QuestionnairePage session={session} data={GROUPS?.[group]?.questionnaire1} onSubmit={handleNextSession} />}
                {session === 2 && <ShortTask session={session} data={GROUPS?.[group]?.shortTask} onSubmit={handleNextSession} startTime={startTime} />}
                {session === 3 && <PracticeTaskPreviewPage session={session} data={GROUPS?.[group]?.preview1} onSubmit={handleNextSession} startTime={startTime} />}
                {session === 4 && <PracticeTask session={session} data={GROUPS?.[group]?.task1} onSubmit={handleNextSession} startTime={startTime} />}
                {session === 5 && <PracticeTaskPreviewPage session={session} data={GROUPS?.[group]?.preview2} onSubmit={handleNextSession} startTime={startTime} />}
                {session === 6 && <PracticeTask session={session} data={GROUPS?.[group]?.task2} onSubmit={handleNextSession} startTime={startTime} />}
                {session === 7 && <QuestionnairePage session={session} data={GROUPS?.[group]?.questionnaire2} onSubmit={handleNextSession} />}
                {isLoading && <LoadingPage />}
            </div>
        )
    }

    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px]' style={{ fontSize }}>


            {/* {isDoingShortTask && <ShortTask
                data={DICT[id]?.shortTaskQuestions}
                onSubmit={() => {
                    setisDoingShortTask(false);
                    setisDoingReadingTask(true);
                }} />}
            {isDoingReadingTask && <PracticeTask
                data={DICT[id]?.practiceTaskData}
                onSubmit={() => {
                    navigate('/platform2/research-practices')
                }} />} */}

            {isLoading && <LoadingPage />}
        </div>
    );
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
